module.exports = __webpack_public_path__ + "static/img/Account.5e642d63.png";